var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20678",
    "data-name": "Group 20678",
    transform: "translate(-162 -459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    transform: "translate(162 459)",
    fill: "#fff",
    stroke: "#6c6c6c",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "QnA",
    d: "M4.536-9.212c0-4.144,2.156-6.468,5.152-6.468,3.248,0,5.18,2.548,5.208,6.468,0,3.892-1.9,6.5-5.068,6.5C6.384-2.716,4.536-5.6,4.536-9.212ZM19.068,3.7c.112,0,.14-.14.056-.224C17.92,2.408,15.6.252,14.28-.952,16.828-2.492,18.4-5.46,18.368-9.3c-.028-5.18-3.164-9.38-8.652-9.38-5.152,0-8.652,4.088-8.652,9.464C1.064-3.752,4.284.28,9.716.28c.308,0,.616-.028.924-.056,1.484,1.4,2.828,2.6,3.64,3.3a.835.835,0,0,0,.448.168ZM21.14-.224c0,.14.056.224.224.224H24.3a.206.206,0,0,0,.224-.224V-10a3.585,3.585,0,0,1,2.716-1.148c1.624,0,2.408,1.064,2.408,2.912v7.98A.223.223,0,0,0,29.9,0h2.912c.14,0,.224-.056.224-.252V-8.54c0-4.48-2.576-5.544-4.676-5.544a6.172,6.172,0,0,0-4.06,1.54,6.1,6.1,0,0,0-.2-1.064c-.056-.14-.14-.2-.336-.2H21.224c-.168,0-.2.056-.2.2.056.56.112,2.072.112,3.024Zm25.48-4.62L48.244-.168a.281.281,0,0,0,.28.168H51.66c.168,0,.2-.084.168-.252L45.36-18.228c-.028-.14-.056-.168-.2-.168H41.272c-.112,0-.168.084-.168.2a4.281,4.281,0,0,1-.252,1.512L35.084-.28c-.028.2.028.28.2.28h2.8a.277.277,0,0,0,.308-.224l1.54-4.62ZM40.824-7.9c.84-2.548,1.96-5.824,2.408-7.7h.028c.56,1.96,1.876,5.852,2.464,7.7Z",
    transform: "translate(174 505)",
    fill: "#6d6d6d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.d4b488aa6783419c9f2ef28076c1c605.svg";
export { ForwardRef as ReactComponent };